module.exports = __webpack_public_path__ + "static/img/bg.6fe05b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = Lr6H
// module chunks = 1 2